(() => {
  const desktopQuery = window.matchMedia('(min-width: 750px)');
  const colorFilterPrefixes = [
    'Details-filter.v.t.shopify.color-pattern',
    'Details-filter.p.m.custom.exact_color_filter',
  ];
  const ratingOrder = new Map([
    ['5 stars', 0],
    ['4 stars & up', 1],
    ['3 stars & up', 2],
    ['2 stars & up', 3],
    ['1 star & up', 4],
  ]);

  const prepareMobileApply = (root = document) => {
    root.querySelectorAll('#FacetFiltersFormMobile').forEach((form) => {
      if (form.dataset.customDeferredApplyReady === 'true') return;
      form.dataset.customDeferredApplyReady = 'true';

      form.addEventListener(
        'input',
        (event) => {
          event.stopPropagation();
        },
        true,
      );
    });
  };

  const reorderRatingOptions = (root = document) => {
    root.querySelectorAll('details[id*="filter.p.m.custom.customer_rating_filter"]').forEach((filter) => {
      filter.querySelectorAll('.facet-checkbox__text[aria-hidden="true"]').forEach((label) => {
        Array.from(label.childNodes).forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE && /\(\d+\)/.test(node.textContent)) node.remove();
        });
      });

      filter.querySelectorAll('ul').forEach((list) => {
      const items = Array.from(list.children);
      const sortedItems = [...items].sort((left, right) => {
        const leftRank = ratingOrder.get(left.querySelector('input')?.value) ?? 99;
        const rightRank = ratingOrder.get(right.querySelector('input')?.value) ?? 99;
        return leftRank - rightRank;
      });

      if (items.some((item, index) => item !== sortedItems[index])) list.append(...sortedItems);
      });
    });
  };

  const positionActiveMobileQuickColor = (root = document) => {
    if (desktopQuery.matches) return;

    root.querySelectorAll('.custom-mobile-quick-colors__list').forEach((list) => {
      const activeItem = list.querySelector('.custom-mobile-quick-colors__item.is-active');
      if (!activeItem) return;
      list.scrollLeft = Math.max(0, activeItem.offsetLeft - (list.clientWidth - activeItem.offsetWidth) / 2);
    });
  };

  const prepareFilters = (root = document) => {
    reorderRatingOptions(root);
    prepareMobileApply(root);
    positionActiveMobileQuickColor(root);
    if (!desktopQuery.matches) return;

    root.querySelectorAll('.facets__wrapper').forEach((wrapper) => {
      const filters = Array.from(wrapper.querySelectorAll(':scope > details.facets__disclosure'));
      const colorFilter = filters.find((filter) => colorFilterPrefixes.some((prefix) => filter.id.startsWith(prefix)));
      const fitOpenFilter = () => {
        const openFilter = filters.find((filter) => filter.open);
        const display = openFilter?.querySelector(':scope > .facets__display');
        wrapper.style.paddingBottom = display ? `${display.scrollHeight + 44}px` : '';
      };

      filters.forEach((filter) => {
        if (filter.dataset.customHorizontalFacetReady === 'true') return;
        filter.dataset.customHorizontalFacetReady = 'true';

        filter.addEventListener('toggle', () => {
          if (filter.open) {
            filters.forEach((otherFilter) => {
              if (otherFilter !== filter) otherFilter.removeAttribute('open');
            });
          }
          requestAnimationFrame(fitOpenFilter);
        });
      });

      if (colorFilter && !filters.some((filter) => filter.open)) colorFilter.open = true;
      requestAnimationFrame(fitOpenFilter);
    });
  };

  document.addEventListener('DOMContentLoaded', () => prepareFilters());
  document.addEventListener('shopify:section:load', (event) => prepareFilters(event.target));
  document.addEventListener('shopify:section:reorder', () => prepareFilters());
  desktopQuery.addEventListener('change', () => prepareFilters());

  document.addEventListener(
    'click',
    (event) => {
      if (desktopQuery.matches) return;

      const applyButton = event.target.closest('.mobile-facets__footer .button--primary');
      const form = applyButton?.closest('facet-filters-form')?.querySelector('#FacetFiltersFormMobile');
      const facetFilters = form?.closest('facet-filters-form');
      if (!form || !facetFilters) return;

      const searchParams = facetFilters.createSearchParams(form);
      facetFilters.onSubmitForm(searchParams, event);
    },
    true,
  );

  const observer = new MutationObserver((mutations) => {
    if (mutations.some((mutation) => mutation.addedNodes.length)) prepareFilters();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
